/* 
this function takes an array of SKUs and sorts them by matching their options 
against the selectedAttributes within the selector. used for prioritizing
a SKU to be selected when a color change event fires but no matching permalink
has been found
*/
export function prioritizeRelatedSKUs({ skus, selectedAttributes }) {
  const matchedSKUs = skus.map((sku) => {
    let matches = 0;
    for (const [attribute, value] of Object.entries(
      sku.optionValuesByAttribute
    )) {
      if (
        selectedAttributes[attribute] &&
        selectedAttributes[attribute].value === value
      ) {
        matches++;
      }
    }
    return {
      ...sku,
      matches,
    };
  });
  matchedSKUs.sort((s1, s2) => s2.matches - s1.matches);
  return matchedSKUs;
}
